import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

import config from 'config';
import { BackendPlugin } from './i18next-backend-plugin';
import { format } from './formatters';

const backend = new BackendPlugin();

const DETECTION_ORDER =  process.env.REACT_APP_TARGET === 'mobile' ?
    ['navigator'] :
    ['querystring', 'cookie', 'localStorage', 'navigator'];

i18n
    .use(backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: config.languages,
        fallbackLng: config.fallback_language,
        lowerCaseLng: true,
        cleanCode: true,
        ns: ['common'],
        defaultNS: 'common',
        debug: process.env.REACT_APP_I18N_DEBUG === 'true',
        interpolation: {
            escapeValue: false,
            format,
        },
        detection: {
            order: DETECTION_ORDER,
            lookupQuerystring: 'lang',
            lookupCookie: 'lang',
            lookupLocalStorage: 'lang',
            caches: ['localStorage', 'cookie'],
        },
        react: {
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b'],
        },
    });

i18n.on('languageChanged', (lng) => {
    moment.locale(lng);
});

export { backend, i18n };
